import { MessageOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Wrapper } from '../Wrapper';
import { ActivityRendererProps } from '../types';

import s from './CommentActivity.module.scss';

const ChangeActivity: React.FC<ActivityRendererProps> = ({
  entity,
  onDelete,
  onEdit,
}) => {
  return (
    <Wrapper
      onEdit={onEdit}
      onDelete={onDelete}
      icon={<MessageOutlined className={s.commentActivity__icon} />}
      entity={entity}
    >
      <div className={s.commentActivity__comment}>{entity.comment?.value}</div>
    </Wrapper>
  );
};

export default observer(ChangeActivity);
